import React, { useEffect, useRef } from 'react';
import { Box, Button, Spinner } from '@cloudscape-design/components';
import { useCopilot } from './CopilotContext';
import { CopilotMessageBubble } from './CopilotMessageBubble';

// Suggested prompts shown in the empty state, organized by scope.
// These are sent directly to the agent when clicked.
const SUGGESTED_PROMPTS = [
  {
    label: 'My audits & tasks',
    prompt:
      'Show all audits and tasks currently assigned to me — include assigned, in-progress, and overdue. Also show any I completed this month.',
  },
  {
    label: 'My preferred site(s) audit summary',
    prompt: 'Give me an audit summary across all my preferred site(s) this month',
  },
  {
    label: 'BU pass rate this month',
    prompt: 'What is the overall audit pass rate for this business unit this month?',
  },
  {
    label: 'Scheduled & in-progress audits',
    prompt:
      'List audits that are scheduled or in progress for my preferred site(s) in the next 2 weeks',
  },
];

export function CopilotMessageList() {
  const { state, sendMessage } = useCopilot();
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [state.messages, state.isLoading]);

  if (state.messages.length === 0 && !state.isLoading) {
    return (
      <Box textAlign="center" color="text-body-secondary" padding={{ vertical: 's' }}>
        <Box variant="h3">Welcome to Astra</Box>
        <Box variant="p" padding={{ bottom: 's' }}>
          I&apos;m here to help with audits, tasks, questions, and more across Gravion.
          Try one of these:
        </Box>
        <div className="copilot-suggested-prompts">
          {SUGGESTED_PROMPTS.map(({ label, prompt }) => (
            <div key={label} className="copilot-suggested-prompt">
              <Button variant="normal" onClick={() => sendMessage(prompt)}>
                {label}
              </Button>
            </div>
          ))}
        </div>
      </Box>
    );
  }

  return (
    <div>
      {state.messages.map((message) => (
        <CopilotMessageBubble key={message.id} message={message} />
      ))}
      {state.isLoading && (
        <Box padding={{ vertical: 's' }}>
          <Spinner size="normal" />{' '}
          <Box variant="span" color="text-body-secondary">
            Thinking...
          </Box>
        </Box>
      )}
      <div ref={bottomRef} />
    </div>
  );
}
